interface Props {
    theadTitle: string[];
    firstTheadTitle: string
}

export default function TheadRatesAll({ theadTitle, firstTheadTitle }: Props) {
    return (
        <thead>
            <tr className="bg-gray-50">
                <th className="sticky left-0 z-10 border-b border-r border-gray-200 bg-gray-50 px-3 py-2 text-center text-[11px] font-semibold text-gray-600">
                {/* <th className="sticky left-0 top-0 z-30 border-b border-r border-gray-200 bg-gray-100 px-3 py-2 text-center text-[11px] font-semibold text-gray-600"> */}
                    {firstTheadTitle}
                </th>
                {theadTitle.map((title, index, array) => (
                    <th key={title} className={`border-b border-r border-gray-200 px-3 py-2 text-center text-[11px] font-semibold text-gray-600 ${index === array.length - 1 ? 'border-r-0' : ''}`}>
                        {title}
                    </th>
                ))}
            </tr>
        </thead>
    )
}
